var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddAccount = function SvgAddAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm0 14.841A6.85 6.85 0 0 1 3.159 10 6.85 6.85 0 0 1 10 3.159 6.85 6.85 0 0 1 16.841 10 6.85 6.85 0 0 1 10 16.841Zm.58-11.606H9.42v4.186H5.236v1.158h4.186v4.186h1.158v-4.186h4.186V9.421h-4.186V5.235Z",
    fill: "#DC9B32"
  })));
};
export default SvgAddAccount;